<div class="sh-form-group" [class.-sh-is-invalid]="isInvalid$ | async">
  <sh-form-label [label]="'components.scanner-input.id' | translate" [for]="'scanner-input-field'" [required]="required"></sh-form-label>
  <div class="sh-input-field-with-action">
    <input
      #scannerInput
      type="text"
      class="sh-input-field sh-form-group__input ng-untouched ng-pristine ng-valid"
      [id]="'scanner-input-field'"
      [formControl]="recordListControl"
      (keydown.enter)="handleItem()"
      />
    <sh-action-item class="sh-action-group__item" [item]="addActionItem"></sh-action-item>
  </div>
  <ul class="sh-tag-list">
    @for (item of scanItems$ | async; track item) {
      <li class="sh-tag sh-tag-list__item" [ngClass]="getTagClass(item)">
        <span class="sh-tag__label">{{ item.id | getShortRecordId }}</span>
        @if (item.state === scanItemState.Loading) {
          <svg
            sh-icon
            [name]="'spinner'"
            class="sh-tag__icon -sh-spin"
            aria-hidden="true"
          ></svg>
        } @else {
          @if (item.state !== scanItemState.Initial) {
            <button class="sh-tag__button" (click)="removeItem(item)">
              <svg sh-icon [name]="'delete'" class="sh-tag__icon" aria-hidden="true"></svg>
            </button>
          }
        }
      </li>
    }
  </ul>
  @if (errorMsgs$ | async; as errors) {
    @if (errors.length > 0) {
      <div class="sh-form-group__feedback">
        @for (error of errors; track error) {
          <p>{{ error }}</p>
        }
      </div>
    }
  }
</div>
